<template>
  <component :is="tag" :class="textKls" :style="textStyle">
    <div v-if="hasStatus" :class="ns.e('status-wrapper')">
      <span :class="statusCls" :style="statusStyle" />
    </div>
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { useFormSize } from '@jdesign-vue/components/form'
import { addUnit, isUndefined } from '@jdesign-vue/utils'
import { textProps } from './text'

defineOptions({
  name: 'JdText',
})

const props = defineProps(textProps)

const textSize = useFormSize()
const ns = useNamespace('text')

const hasStatus = computed(
  () => props.status !== null && props.status !== undefined
)

const textKls = computed(() => [
  ns.b(),
  ns.m(props.type),
  ns.m(textSize.value),
  ns.is('status', hasStatus.value),
  ns.is('dashed', props.dashed),
  ns.is('truncated', props.truncated),
  ns.is('line-clamp', !isUndefined(props.lineClamp)),
])

const textStyle = computed(() => {
  return {
    '-webkit-line-clamp': props.lineClamp,
    'text-decoration-color': props.dashedColor,
    'text-decoration-thickness': props.dashedSize ? addUnit(props.dashedSize) : '',
    'text-underline-offset': props.dashedOffset ? addUnit(props.dashedOffset) : '',
  }
})

const statusCls = computed(() => [
  ns.e('status'),
  ns.em('status', props.status),
])
</script>
